import React from 'react';
import Conversation from '../components/Conversation'
import {createRoot} from 'react-dom/client';

let root = null;

function isAppVarsReady() {
    return (
        typeof window.current_user_uuid !== 'undefined' &&
        typeof window.messaging_signature !== 'undefined' &&
        window.current_user_uuid &&
        window.messaging_signature
    );
}

window.SendbirdConversation = {
    init(conversationId, channelUrl) {
        waitForAppVars(() => {
            start(conversationId, channelUrl);
        });
    },

    destroy() {
        console.debug("Ending Sendbird conversation");
        if (root) {
            try {
                root.unmount();
            } catch (e) {
                console.warn('SendbirdConversation: unmount failed', e);
            }
        }
        root = null;
    }
};

function waitForAppVars(onReady, {timeoutMs = 8000, pollMs = 50} = {}) {
    if (isAppVarsReady()) {
        onReady();
        return;
    }
    const startAt = Date.now();
    const timer = setInterval(() => {
        if (isAppVarsReady()) {
            clearInterval(timer);
            onReady();
        } else if (Date.now() - startAt > timeoutMs) {
            clearInterval(timer);
            console.warn("SendbirdConversation: app vars not ready before timeout; proceeding anyway");
            onReady();
        }
    }, pollMs);
}

const start = (conversationId, channelUrl) => {
    console.debug("Starting Sendbird conversation");
    const container = document.getElementById("sendbird-container");
    if (!container) {
        window.sentry?.captureMessage("Sendbird container not found");
        return;
    }
    if (!channelUrl) {
        window.sentry?.captureMessage("Channel URL not found");
        return;
    }
    if (!conversationId) {
        window.sentry?.captureMessage("Conversation ID not found");
        return;
    }
    root = createRoot(container);
    root.render(
        <Conversation
            userId={window.current_user_uuid}
            accessToken={window.messaging_signature}
            channelUrl={channelUrl}
            conversationId={conversationId}
        />
    );
};
